<template>
  <div class="create-story-page">
  	<!-- header-bottom-start -->
   	<header-bottom></header-bottom>
  	<!-- header-bottom-end -->


  	<!-- inner-wrapper-start -->
  	<div class="inner-wrap">

        <!-- for desktop area start -->
        <div class="d-none-sm">
          <!-- aside start -->
          <sidebar-left></sidebar-left>
          <!-- aside end -->

          <!-- main-content start -->
          <main-content :class="{'show-sidebar':show }"></main-content>
          <!-- main-content end -->

          <!-- right-sidebar start -->
          <sidebar-right @showbar="showbar"></sidebar-right>
          <!-- right-sidebar end -->
          <v-tour name="myTour" :steps="steps"></v-tour>
        </div>
        <!-- for desktop area end -->


        <!-- for mobile area start -->
        <div class="d-none-lg d-block-sm" :class="{'colModalOpen': collectionModal}">
          <splitpanes class="default-theme mobileAreaSplit" horizontal>
            <pane size="100">
              <!-- aside start -->
              <sidebar-left></sidebar-left>
              <!-- aside end -->

              <!-- main-content start -->
              <main-content :class="{'show-sidebar':show}"></main-content>
              <!-- main-content end -->
            </pane>
            <!-- right-sidebar start -->
            <pane style="z-index: 1" min-size="0" max-size="80" v-if="show">
              <sidebar-right @showbar="showbar"></sidebar-right>
            </pane>
            <!-- right-sidebar end -->
          </splitpanes>
          <v-tour name="myTour2" :steps="steps2"></v-tour>
        </div>
        <!-- for mobile area end -->

  	</div>
  	<!-- inner-wrapper-end -->

  </div>
</template>


<script>
import { EventBus } from '../main';
import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';


  export default {
    components: { Splitpanes, Pane },
    data() {
      return {
        collectionModal:false,
        show:false,
        steps: [
          {
            target: '#v-step-0',  // We're using document.querySelector() under the hood
            content: `Start typing and click here to add a new page`,
            params: {
              placement: 'right'
            },
            labels: {
              buttonNext: 'Ok'
            }
          },
          {
            target: '#v-step-1',  // We're using document.querySelector() under the hood
            content: `Already wrote a story or prefer typing in a word doc?`,
            params: {
              placement: 'bottom'
            }
          },

        ],
        steps2: [
          {
            target: '[data-v-step="10"]',
            content: `Start typing and click here to add a new page`,
            params: {
              placement: 'bottom'
            },
            labels: {
              buttonNext: 'Ok'
            }
          },
          {
            target: '[data-v-step="11"]',
            content: `Already wrote a story or prefer typing in a word doc?`,
            params: {
              placement: 'top'
            }
          }

        ],
      }
    },

    methods: {
      showbar(data){
        this.show = data;
      }
    },

    mounted: function () {
      this.$tours['myTour'].start();
      this.$tours['myTour2'].start();
    },


    created() {
      // Using the server bus
      EventBus.$on('showBtm', data => {
        if(this.show==true && data==true){
          this.show=false
        } else {
          this.show=data;
        }
      });
      // Is collection modal open or not
      EventBus.$on('showCollectionModal', data => {
        this.collectionModal=data;
      });
    }

  }
</script>

<style type="text/css">
  .inner-wrap {
      position: relative;
  }

  .main-content.show-sidebar {
      margin-right: 20.5%;
  }

  div#v-step-74be903e,
  div#v-step-74be97c0,
  div#v-step-46f34ed8,
  div#v-step-46f34eda {
      width: 260px;
      border-radius: 15px;
      background: #ffffff;
      -webkit-box-shadow: 0px 2px 4px rgba(33,65,99,0.05);
              box-shadow: 0px 2px 4px rgba(33,65,99,0.05);
      -webkit-box-sizing: border-box;
              box-sizing: border-box;
  }

  .v-step__content>div {
    color: #214163;
    font-family: Lato;
    font-size: 18px;
    font-weight: 700;
    line-height: 25px;
    text-align: center;
    letter-spacing: 0.5px;
  }

  .v-step[x-placement^=bottom][data-v-aa0cbe42] {
      top: -135px !important;
  }

  button.v-step__button {
      width: 75px;
      height: 35px;
      border-radius: 10px;
      background: #00c6c6 !important;
      border-radius: 5px !important;
  }
  .mobileAreaSplit{
    height: 100vh;
  }


  @media only screen and (max-width: 768px) {

    .colModalOpen #pane_1 {
        z-index: 2 !important;
    }

    .splitpanes__splitter {
        width: 75%;
        margin: -7px auto;
        z-index: 2;
    }
    .default-theme.splitpanes--horizontal>.splitpanes__splitter{
        border-top: 0px solid #eee;
        position: relative;
        top: 5px;
        padding-bottom: 11px;
    }
  }



  @media only screen and (max-width: 660px) and (orientation: landscape) {
   
    .mobileAreaSplit{
      height: auto;
      min-height: 100vh;
    }

  }

  @media only screen and (max-width: 480px) {
    .collection-btn button {
        width: 35px !important;
        height: 35px !important;
    }

    .collection-btn button svg {
        transform: scale(.8);
    }

    .copyLink {
      margin-top: 15px !important;
        -webkit-box-shadow: 0px 13px 30px rgba(35, 48, 73, 0.28) !important;
        box-shadow: 0px 13px 30px rgba(35, 48, 73, 0.28) !important;
    }

    .copyLink.showLink:after {
        left: 37% !important;
    }

  }


</style>